import type { IReferenceGroupFavorites } from '@repo/reference-wells';

import type { IUserPreferenceService } from 'src/packages/user-preference/IUserPreferenceService';

/**
 * Adapts dashboard UserPreference into the reference-wells favorites port.
 */
export class ReferenceGroupFavoritesAdapter implements IReferenceGroupFavorites {
  constructor(private readonly userPreference: IUserPreferenceService) {}

  get favoriteIds(): readonly string[] {
    return this.userPreference.preferences.favoriteReferenceGroupIds ?? [];
  }

  isFavorite(groupId: string): boolean {
    return this.favoriteIds.includes(groupId);
  }

  toggleFavorite(groupId: string): void {
    const current = [...this.favoriteIds];
    const next = this.isFavorite(groupId) ? current.filter((id) => id !== groupId) : [...current, groupId];

    this.userPreference.updatePreferences({ favoriteReferenceGroupIds: next });
  }
}
